import { useRef, useState } from "react";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ImageUpload = ({ value, onChange, label = "Immagine", testid = "image-upload" }) => {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd);
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error(apiError(err, "Caricamento fallito. Riprova."));
    } finally {
      setLoading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div data-testid={testid}>
      <Label className="font-accent text-xs uppercase tracking-[0.18em] text-sage">{label}</Label>
      <div className="mt-2 flex items-start gap-4">
        {value ? (
          <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-sm bg-sand">
            <img src={value} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => onChange("")}
              className="absolute right-1 top-1 rounded-full bg-forest/80 p-1 text-bone"
              data-testid={`${testid}-remove`}
              aria-label="Rimuovi immagine"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : null}
        <div className="flex-1">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-sm border border-dashed border-line bg-sand/50 px-4 py-3 font-accent text-xs uppercase tracking-[0.18em] text-sage transition-colors duration-300 hover:border-forest hover:text-forest disabled:opacity-60"
            data-testid={`${testid}-upload`}
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" strokeWidth={1.5} />}
            {loading ? "Caricamento…" : value ? "Sostituisci foto" : "Carica foto"}
          </button>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            className="hidden"
            onChange={upload}
            data-testid={`${testid}-file`}
          />
          <Input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="oppure incolla un URL https://…"
            className="mt-2 border-line bg-sand/70 text-xs text-forest"
            data-testid={`${testid}-url`}
          />
        </div>
      </div>
    </div>
  );
};
